import { useMutation } from "@tanstack/react-query";
import { logout as logoutApi } from "@core/libs/axios/services/authRequests";
import { performLogout } from "@core/libs/axios/services/performLogout";

export function useLogout() {
  const logoutMutation = useMutation({
    mutationFn: async () => {
      await logoutApi();
    },
    onSuccess: () => {
      performLogout();
    },
    onError: () => {
      // Force local logout even if API call fails
      performLogout();
    },
  });

  return {
    logout: () => logoutMutation.mutate(),
    isLoggingOut: logoutMutation.isPending,
    logoutError: logoutMutation.error,
  };
}
